/**
 * 所属模块
 */
exports.SEA_BOOKING_MODULE = 1 // 海运订舱
exports.AIR_BOOKING_MODULE = 2 // 空运订舱
exports.REMOTE_BOOKING_MODULE = 3 // 远程订舱
exports.SEA_VERIFY_BOOKING_MODULE = 4 // 海出/订舱预审
exports.RAILWAY_BOOKING_MODULE = 5 // 铁路操作
exports.AI_BOOKING_MODULE = 6 // 空运操作
exports.SI_BOOKING_MODULE = 7 // 海运操作
exports.IC_BOOKING_MODULE = 8 // 综合物流-国际卡航
exports.CL_BOOKING_MODULE = 9 // 综合物流-整车零担
exports.TT_BOOKING_MODULE = 10 // 综合物流-集卡拖车
exports.SALES_INQUIRY_MODULE = 11 // 销售模块-销售查询
exports.AIR_BOOKING_VERIFY = 12 // 空出-订单预审
exports.BILLING_NATIVE_MODULE = 13 // 对账-对账页签
exports.INVOICE_MODULE = 14 // 结算-开票
exports.BILLPAYMENT_NATIVE_MODULE = 15 // 付款申请（基础版）
exports.COMPANY_NATIVE_MODULE = 16 // 合作伙伴

exports.MODULES = [exports.SEA_BOOKING_MODULE, exports.AIR_BOOKING_MODULE, exports.REMOTE_BOOKING_MODULE, exports.SEA_VERIFY_BOOKING_MODULE, exports.RAILWAY_BOOKING_MODULE,
  exports.AI_BOOKING_MODULE, exports.SI_BOOKING_MODULE, exports.IC_BOOKING_MODULE, exports.CL_BOOKING_MODULE, exports.TT_BOOKING_MODULE, exports.SALES_INQUIRY_MODULE, exports.INVOICE_MODULE, exports.AIR_BOOKING_VERIFY]

/**
 * 页签类型
 */
exports.SEA_BOOKING_BASIC = 1 // 海运订舱-基本页签
exports.SEA_BOOKING_VESSEL = 2 // 海运订舱-订舱页签
exports.AIR_BOOKING_BASIC = 3 // 空运订舱-基本页签
exports.AIR_BOOKING_VESSEL = 4 // 空运订舱-订舱页签
exports.REMOTE_SEA_BOOKING_BASIC = 5 // 远程订舱-海运订舱-委托页签
exports.REMOTE_AIR_BOOKING_BASIC = 6 // 远程订舱-空运订舱-委托页签
exports.REMOTE_RE_BOOKING_BASIC = 7 // 远程订舱-铁路订舱-出口委托页签
exports.REMOTE_RI_BOOKING_BASIC = 8 // 远程订舱-铁路订舱-进口委托页签
exports.SEA_VERIFY_BOOKING_BASIC = 9 // 海出/订舱预审-基本页签
exports.SEA_VERIFY_BOOKING_VESSEL = 10 // 海出/订舱预审-订舱页签
exports.RAILWAY_BOOKING_RE_BASIC = 11 // 铁路操作-出口基本页签
exports.RAILWAY_BOOKING_RI_BASIC = 12 // 铁路操作-进口基本页签
exports.AI_BOOKING_BASIC = 13 // 空运操作-基本页签
exports.SI_BOOKING_BASIC = 14 // 海运操作-基本页签
exports.SI_BOOKING_ARRIVAL_INFO = 15 // 海运操作-到港信息签
exports.SEA_BOOKING_MBL = 16 // 海运订舱-MBL页签
exports.SEA_BOOKING_MBL_SPLIT = 17 // 海运订舱-MBL拆单页签
exports.SEA_BOOKING_MBL_MERGE = 18 // 海运订舱-MBL并单页签
exports.SEA_BOOKING_FILE_HISTORY = 19 // 海运订舱-文件历史页签
exports.SEA_BOOKING_HBL = 20 // 海运订舱-HBL页签
exports.SEA_BOOKING_HBL_SPLIT = 21 // 海运订舱-HBL拆单页签
exports.SEA_BOOKING_HBL_MERGE = 22 // 海运订舱-HBL并单页签
exports.SEA_BOOKING_VIRTUAL_HBL = 23 // 海运订舱-形式分单页签
exports.SEA_BOOKING_CHARGE_RECEIVABLE = 24 // 海运订舱-费用（应收）
exports.SEA_BOOKING_CHARGE_PAYABLE = 25 // 海运订舱-费用（应付）
exports.SEA_BOOKING_SPECIAL_GOODS = 26 // 海运订舱-特殊货物信息
exports.SEA_BOOKING_CUSTOMS = 27 // 海运订舱-报关
exports.SEA_BOOKING_TRUCKING = 28 // 海运订舱-客户门点
exports.SEA_BOOKING_DISCHARGING_TRUCKING = 29 // 海运订舱-目的港派车
exports.INTEGRATED_IC_BOOKING = 30 // 综合物流-国际卡航页签
exports.SEA_BOOKING_DOMESTIC_BILLING = 31 // 海运订舱-国内账单
exports.SALES_INQUIRY_SE_BASIC = 32 // 销售模块-销售查询-海运出口-基本页签
exports.AIR_VERIFY_BOOKING_BASIC = 33 // 空出/订单预审-基本页签
exports.INTEGRATED_CL_BOOKING = 34 // 综合物流-整车零担页签
exports.INTEGRATED_TT_BOOKING = 35 // 综合物流-集卡拖车页签
exports.BILLING_NATIVE_RECONCILIATION = 36 // 结算-对账-对账页签
exports.INVOICE_QUERY = 37 // 结算-开票-发票查询页签
exports.BILLPAYMENT_NATIVE_SUPERVISOR_APPROVAL = 39 // 结算-付款申请-待主管审批页签
exports.BILLPAYMENT_NATIVE_DEPARTMENT_APPROVAL = 40 // 结算-付款申请-待部门审批页签
exports.SEA_BOOKING_CONTAINER_INFO = 38 // // 海运订舱-箱货信息
exports.SEA_BOOKING_OVERSEA_BILL = 41 // 海运订舱-国外账单
exports.SALES_INQUIRY_LIST = 42 // 销售模块-销售查询-列表页签
exports.REMOTE_BOOKING_LIST = 43 // 销售模块-远程订舱-列表页签
exports.AIR_BOOKING_CHARGE_RECEIVABLE = 44 // 空运订舱-费用（应收）
exports.AIR_BOOKING_CHARGE_PAYABLE = 45 // 空运订舱-费用（应付）
exports.SEA_BOOKING_CONTAINER_INFO_MASTER = 46 // 海运订舱-箱货信息-主票

exports.COMPANY_NATIVE_CUSTOMER_VENDOR_RATING = 50 // 基础资料-合作伙伴-客商评分
exports.BILLING_NATIVE_BILL = 51 // 结算-对账-账单页签

exports.PAGE_TYPES = [
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_BASIC
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_VESSEL
  },
  {
    module: exports.AIR_BOOKING_MODULE,
    pageType: exports.AIR_BOOKING_BASIC
  },
  {
    module: exports.AIR_BOOKING_MODULE,
    pageType: exports.AIR_BOOKING_VESSEL
  },
  {
    module: exports.REMOTE_BOOKING_MODULE,
    pageType: exports.REMOTE_SEA_BOOKING_BASIC
  },
  {
    module: exports.REMOTE_BOOKING_MODULE,
    pageType: exports.REMOTE_AIR_BOOKING_BASIC
  },
  {
    module: exports.REMOTE_BOOKING_MODULE,
    pageType: exports.REMOTE_RE_BOOKING_BASIC
  },
  {
    module: exports.REMOTE_BOOKING_MODULE,
    pageType: exports.REMOTE_RI_BOOKING_BASIC
  },
  {
    module: exports.SEA_VERIFY_BOOKING_MODULE,
    pageType: exports.SEA_VERIFY_BOOKING_BASIC
  },
  {
    module: exports.SEA_VERIFY_BOOKING_MODULE,
    pageType: exports.SEA_VERIFY_BOOKING_VESSEL
  },
  {
    module: exports.RAILWAY_BOOKING_MODULE,
    pageType: exports.RAILWAY_BOOKING_RE_BASIC
  },
  {
    module: exports.RAILWAY_BOOKING_MODULE,
    pageType: exports.RAILWAY_BOOKING_RI_BASIC
  },
  {
    module: exports.AI_BOOKING_MODULE,
    pageType: exports.AI_BOOKING_BASIC
  },
  {
    module: exports.SI_BOOKING_MODULE,
    pageType: exports.SI_BOOKING_BASIC
  },
  {
    module: exports.SI_BOOKING_MODULE,
    pageType: exports.SI_BOOKING_ARRIVAL_INFO
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_MBL
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_MBL_SPLIT
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_MBL_MERGE
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_FILE_HISTORY
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_HBL
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_HBL_SPLIT
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_HBL_MERGE
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_VIRTUAL_HBL
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_CHARGE_RECEIVABLE
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_CHARGE_PAYABLE
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_SPECIAL_GOODS
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_CUSTOMS
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_TRUCKING
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_DISCHARGING_TRUCKING
  },
  {
    module: exports.IC_BOOKING_MODULE,
    pageType: exports.INTEGRATED_IC_BOOKING
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_DOMESTIC_BILLING
  },
  {
    module: exports.SALES_INQUIRY_MODULE,
    pageType: exports.SALES_INQUIRY_SE_BASIC
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_CONTAINER_INFO
  },
  {
    module: exports.CL_BOOKING_MODULE,
    pageType: exports.INTEGRATED_CL_BOOKING
  },
  {
    module: exports.TT_BOOKING_MODULE,
    pageType: exports.INTEGRATED_TT_BOOKING
  },
  {
    module: exports.BILLING_NATIVE_MODULE,
    pageType: exports.BILLING_NATIVE_RECONCILIATION
  },
  {
    module: exports.BILLING_NATIVE_MODULE,
    pageType: exports.BILLING_NATIVE_BILL
  },
  {
    module: exports.INVOICE_MODULE,
    pageType: exports.INVOICE_QUERY
  },
  {
    module: exports.BILLPAYMENT_NATIVE_MODULE,
    pageType: exports.BILLPAYMENT_NATIVE_SUPERVISOR_APPROVAL
  },
  {
    module: exports.BILLPAYMENT_NATIVE_MODULE,
    pageType: exports.BILLPAYMENT_NATIVE_DEPARTMENT_APPROVAL
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_OVERSEA_BILL
  },
  {
    module: exports.AIR_BOOKING_VERIFY,
    pageType: exports.AIR_VERIFY_BOOKING_BASIC
  },
  {
    module: exports.SALES_INQUIRY_MODULE,
    pageType: exports.SALES_INQUIRY_LIST
  },
  {
    module: exports.REMOTE_BOOKING_MODULE,
    pageType: exports.REMOTE_BOOKING_LIST
  },
  {
    module: exports.AIR_BOOKING_MODULE,
    pageType: exports.AIR_BOOKING_CHARGE_RECEIVABLE
  },
  {
    module: exports.AIR_BOOKING_MODULE,
    pageType: exports.AIR_BOOKING_CHARGE_PAYABLE
  },
  {
    module: exports.COMPANY_NATIVE_MODULE,
    pageType: exports.COMPANY_NATIVE_CUSTOMER_VENDOR_RATING
  },
  {
    module: exports.SEA_BOOKING_MODULE,
    pageType: exports.SEA_BOOKING_CONTAINER_INFO_MASTER
  }
]
